export enum AppPathEnum {
  MAIN = "/main",
  USERS = "/users",
}
